/** Footer copy. */
export const footerCopy = {
  links: [
    { href: '#waitlist', label: 'Lista de espera' },
    { href: 'mailto:hello@nyx.space', label: 'Contacto' },
  ],
  lyricsDisclaimer: 'Letras pertenecen a sus respectivos titulares.',
  copyrightYear: 2026,
} as const;
